var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wxseparation"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.conte_show),expression:"conte_show"}],staticClass:"wxseparation_content",domProps:{"innerHTML":_vm._s(_vm.conte)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fa3ebf5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/wxseparation/wxprotolsecrets.vue
// module id = null
// module chunks = 